export const EnableBeepsDefinitions = [
  {
    value: 'true',
    details: 'Xirgocam will make audible beep sounds when making clips'
  },
  {
    value: 'false',
    details: 'Xirgocam will NOT make audible beep sounds when making clips'
  }
]